export const marketsRoot = "markets";
